
import React, { PropTypes } from 'react';

export class Close extends React.Component {

  static propTypes = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    callback: PropTypes.func,
    classes: PropTypes.string
  };

  render () {
    const stroke = this.props.color === 'primary'
      ? '#00587c'
      : this.props.color;

    const containerClass = this.props.classes || '';

    return (
      <div
        className={containerClass}
        onClick={this.props.callback} >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.width || '24'}
          height={this.props.height || '24'}
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M22 2L2 22M2 2L22 22"
            stroke={stroke}
            strokeWidth="4" strokeLinecap="round"/>
        </svg>
      </div>
    );
  }
}

export default Close;



/** WEBPACK FOOTER **
 ** ./src/components/svg/close.js
 **/